import { Icon, IconNames, Text, Tooltip } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { ReactNode } from 'react';

import styles from './teamChannelIcon.module.scss';

type TeamChannelIconsProps = {
  active: boolean;
  status: 'away' | 'offline' | 'working' | string;
  icon: IconNames;
  numberOfConversations?: number;
  tooltip?: ReactNode;
} & PropsWithClassName;

export const TeamChannelIcon = ({
  className,
  active,
  status,
  icon,
  numberOfConversations,
  tooltip,
}: TeamChannelIconsProps): JSX.Element => {
  const withText = numberOfConversations !== undefined;
  const away = status === 'away';
  const offline = status === 'offline';
  const working = status === 'working';
  const enabled = active;

  const rootClass = classnames(
    {
      [styles.iconBackground]: true,
      [styles.iconBackgroundGreen]: working && enabled,
      [styles.iconBackgroundOrange]: away && enabled,
      [styles.iconBackgroundGray]: offline || !enabled,
      [styles.iconBackgroundWithText]: withText,
    },
    className,
  );

  const color =
    working && enabled
      ? colors.green[600]
      : away && enabled
        ? colors.orange[600]
        : colors.neutral[400];

  const cappedConversations =
    numberOfConversations && numberOfConversations > 9
      ? '9+'
      : numberOfConversations;

  const content = (
    <div className={rootClass}>
      <Icon name={icon} color={color} />

      {withText && (
        <Text.Heading
          as="span"
          variant="heading-3"
          color={color}
          className={styles.text}
        >
          {cappedConversations}
        </Text.Heading>
      )}
    </div>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{content}</Tooltip>;
  }

  return content;
};
